module.exports = __webpack_public_path__ + "static/media/colorShareIcon.10964a35.svg";